import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute  } from "@angular/router";
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { User} from 'src/app/Model/User/user.model';
import { Location } from '@angular/common';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  currentUser:User;
  loggedInUserBranch;
  loggedInUserFullname;
  loggedInUsername;
  loggedInUserId;
  constructor(private router: Router,
    private _location: Location,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,) { 
      
    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if(this.currentUser){
      this.loggedInUsername=this.currentUser.userName;
    this.loggedInUserFullname=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
    this.loggedInUserBranch=this.currentUser.branch;
    this.loggedInUserId=this.currentUser.userName;
console.log(this.loggedInUsername);
    }
  }

  ngOnInit(): void {

    
  }

  noAppointmentQuestionaire(){
    if(this.currentUser){
      if(this.loggedInUsername=="8810device"){
        this.router.navigate(['../device-logistic-appointment-questionaire',],{relativeTo:this.actroute});
      }else{
      this.router.navigate(['../device-appointment-questionaire',],{relativeTo:this.actroute});
      }
    }else{
      this.router.navigate(['../appointment-questionaire',],{relativeTo:this.actroute});
    }
  }
}
